/**
 * MatchColumns
 */

import React, { useEffect, useReducer } from 'react';
import PropTypes from 'prop-types';
import produce from 'immer';
import { FormattedMessage } from 'react-intl';
import messages from './messages.js';

function MatchColumns(props) {
  const { fields, columns, onChange, value } = props;
  const getInitialState = () => value || fields.list.reduce((acc, v, i) => ({ ...acc, [v]: columns[i] }), {});
  const reducer = produce((draft, action) => {
    const { field, val } = action;
    draft[field] = val;
    // onChange(asObject(draft));
  });
  const [state, dispatch] = useReducer(reducer, getInitialState());
  function handleChange(ev) {
    const { target } = ev;
    dispatch({ field: target.id, val: target.value });
  }
  useEffect(() => onChange(state), [state]);
  function errorClass(field) {
    return Object.keys(state).every((key) => key === field ? state[key] !== undefined : state[key] !== state[field]) ? '' : 'has-error';
  }
  return (
    <table className="table w-auto">
      <thead>
        <tr>
          <th><FormattedMessage {...messages.dataField} /></th>
          <th><FormattedMessage {...messages.sheetColumn} /></th>
        </tr>
      </thead>
      <tbody>
        {fields.list.map((field) => (
          <tr key={field}>
            <td className="align-middle">{fields[field]}</td>
            <td className={errorClass(field)}>
              <select value={state[field]} id={field} className="form-control" onChange={handleChange}>
                <option value="">--</option>
                {columns.map((col) => <option key={col} value={col}>{col}</option>)}
              </select>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

MatchColumns.propTypes = {
  fields: PropTypes.object.isRequired,
  value: PropTypes.object,
  columns: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default MatchColumns;
